import React from "react";
import ActivityLog from "../../../assets/images/activity-log.png";
import { useTranslation } from "react-i18next";

export const EmptyRefunds = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 460
      }}
    >
      <img src={ActivityLog} alt="Refunds placeholder" />
      <p className="text">{t("empty_refunds")}</p>
    </div>
  );
};
